/*
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-10-19 13:36:32
 */
import React from 'react'

interface BatchPreviewGridProps {
  images?: string[]
  tip?: string
  width?: number
  height?: number
}

const BatchPreviewGrid: React.FC<BatchPreviewGridProps> = ({
  images = [],
  tip = '批量识别中',
  width = 200,
  height = 200
}) => {
  const displayImages = Array.isArray(images) ? images.slice(0, 5) : []
  const totalCount = Array.isArray(images) ? images.length : 0

  return (
    <div
      style={{
        width,
        height,
        position: 'relative',
        border: '1px solid #d9d9d9',
        borderRadius: 4,
        overflow: 'hidden',
        background: '#f5f5f5'
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '100%',
          transform: 'translate(-50%, -50%)',
          padding: '6px 10px',
          background: 'rgba(0,0,0,0.5)',
          color: '#fff',
          fontSize: 12,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 8,
          zIndex: 2,
          pointerEvents: 'none',
          textAlign: 'center',
          whiteSpace: 'normal',
          wordBreak: 'break-word'
        }}
      >
        <span style={{ fontWeight: 500 }}>{tip}</span>
        <span style={{ opacity: 0.9 }}>· 已选{totalCount}张</span>
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gridTemplateRows: 'repeat(2, 1fr)',
          gap: 4,
          width: '100%',
          height: '100%',
          padding: 8,
          boxSizing: 'border-box'
        }}
      >
        {displayImages.map((img, idx) => {
          const count = displayImages.length
          const span = count === 5 && idx === 4 ? '2 / span 2' : 'auto'
          return (
            <div
              key={idx}
              style={{
                backgroundImage: `url(${img})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                borderRadius: 4,
                border: '1px solid #eee',
                gridColumn: span
              }}
            />
          )
        })}
      </div>
    </div>
  )
}

export default BatchPreviewGrid
